export default {
      id: "icon-twitter-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }